<template>
  <div class="form-section group">
    <span class="icon"><icon-colored-purchase-type /></span>
    {{ capitalize(i('names.purchaseType', 1)) }}
  </div>
  <div
    v-show="!purchaseTypeOverridable"
    class="form-section-content">
    <div
      v-show="!purchaseTypeOverridable"
      class="form-group row">
      <form-label for-i-d="edit_package_deal_type">{{ capitalize(i('messages.chooseOnePurchaseType')) }}: </form-label>
      <div
        id="edit_package_deal_type"
        class="col-sm-9">
        <selectable-tiles
          :items="purchaseTypes"
          :should-display-labels="true"
          :should-display-icons="true"
          :should-display-checkmark-on-selected-items="true"
          label-property-name="name"
          description-property-name="description"
          icon-property-name="icon"
          :selected-items="[purchaseType]"
          :is-multiselect="false"
          :allow-empty="false"
          :justify-content-left="true"
          min-tile-width="18rem"
          :show-primary-badge-color="true"
          :disabled-unselected-tiles="!canEditPurchaseType"
          @selection-changed="emits('onPurchaseTypeChanged', $event)" />
        <span
          v-show="errors.has('purchaseType')"
          class="help is-danger"
          >{{ errors.first('purchaseType') }}</span
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize, inject, Ref } from 'vue';

  import { FormLabel, SelectableTiles } from '@/common/components/controls';
  import { IconColoredPurchaseType } from '@/common/icons/colored';
  import { Package, PurchaseTypeOptions } from '@/common/models';
  import { i, useInjected } from '@/globals';
  import { useDealComputedProperties } from '@/org-app/services/computedProperties/DealComputedProperties';
  import MessageCollection from '@/validator/MessageCollection';

  interface IProps {
    purchaseType: PurchaseTypeOptions;
    purchaseTypes: PurchaseTypeOptions[];
    canEditPurchaseType: boolean;
  }
  const { purchaseType, purchaseTypes, canEditPurchaseType } = defineProps<IProps>();

  const deal: Ref<Package> = useInjected<Package>('deal');
  const errors: Ref<MessageCollection> = inject('errors', null);

  const emits = defineEmits(['onPurchaseTypeChanged']);

  const { purchaseTypeOverridable } = useDealComputedProperties(deal);
</script>

<style scoped lang="scss">
  @use '@/styles/variables' as *;
</style>
